/**
 * 枚举
 * Created by JiangChuanqi on 2017/8/14.
 */
/** 账号是否锁定*/
export const ACCOUNT_NON_LOCKED = {
  LOCKED: { key: 1, label: '可用' },
  UNLOCKED: { key: 0, label: '禁用' },
}

/** 账号是否可用*/
export const USER_STATUS = {
  LOCKED: { key: 'valid', label: '可用' },
  UNLOCKED: { key: 'invalid', label: '不可用' },
}

// 审核结果类型
export const CEHCKRESULT = {
  init : { key: 'init', label: '未审核' },
  dealed : { key: 'dealed', label: '已整改' },
  undeal : { key: 'undeal', label: '未处理' },
  unpass : { key: 'unpass', label: '驳回' },
  pass : { key: 'pass', label: '已审核未整改' },
}

// 审核结果类型初始化时
export const CEHCKRESULTINIT = {
  unpass : { key: 'unpass', label: '驳回' },
  undeal : { key: 'undeal', label: '已审核未整改' },
}
// 审核结果类型审核通过时
export const CEHCKRESULTPASS = {
  dealed : { key: 'dealed', label: '已整改' }
}

/** 账号是否有管辖区域*/
export const IS_EXIST_CHARGE_RANGE = {
  LOCKED: { key: '1', label: '是' },
  UNLOCKED: { key: '0', label: '否' },
}

/** 角色类型 */
export const IS_SYSTEM_ROLE = {
  YES: { key: 'yes', label: '系统内置角色', color: '#ed4014' },
  NO: { key: 'no', label: '自定义角色', color: '#5dc8b2' },
}

/** 用户类型 */
export const USER_TYPE = {
  SYSTEM_USER: { key: '1', label: '系统用户' },
  NORMAL_USER: { key: '2', label: '普通用户' },
}
/** 党员类型 */
export const PARTYMENBER = {
  flag: { key: 'flag', label: '是' },
  inflag: { key: 'inflag', label: '否' },
}

/** 通用状态：1-正常  0-停用*/
export const COMMON_STATUS = {
  NORMAL: { key: 1, label: '正常', color: '#5dc8b2' },
  DISABLE: { key: 0, label: '停用', color: '#ed4014' },
}

/** 部门类型 */
export const DEPARTMENT_TYPE = {
  MECHANISM: { key: 'mechanism', label: '机构' },
  DEPARTMENT: { key: 'department', label: '部门' },
}

/** 通用判断：1-是  0-否*/
export const COMMON_YES_NO = {
  YES: { key: 1, label: '是', color: '#ed4014' },
  NO: { key: 0, label: '否', color: '#5dc8b2' },
}

/** 新闻状态 **/
export const NEWS_STATUS = {
  yes: { key: 'yes', label: '已发布' },
  no: { key: 'no', label: '未发布' },
}

/** 新闻类型 */
export const NEWS_TYPE = {
  regulatory: { key: 'regulatory', label: '规章制度' },
  video: { key: 'video', label: '优秀视频' },
  story: { key: 'story', label: '典型事迹' },
}

/* 枚举-是否 */
export const COMMON_TRUE_FALSE = {
  TRUE: { key: 'TRUE', label: '是' },
  FALSE: { key: 'FALSE', label: '否' },
}

export const COMMON_COMMODITY_STATUS = {
  ONLINE: { key: 'ONLINE', label: '上架' },
  OFFLINE: { key: 'OFFLINE', label: '下架' },
}
//app类型
export const APP_TYPE = {
  IOS: { key: 'IOS', label: '苹果' },
  ANDROID: { key: 'ANDROID', label: '安卓' },
}

/** 通过key寻找枚举 */
export const findByKey = (enumSet, key) => {
  return toList(enumSet).find((e) => e.key == key);
}

/** 转成列表 */
export const toList = (enumSet) => {
  let list = [];
  Object.keys(enumSet).forEach(function (key) {
    list.push(enumSet[key]);
  });
  return list;
}
/** 结果 **/
export const PHOTOEXAMINE_RESULT = {
  NO: { key: 'NO', label: '未评' },
  APPROVE_TOTAL_YES: { key: 'APPROVE_TOTAL_YES', label: '好' },
  APPROVE_NO: { key: 'APPROVE_NO', label: '差' },
  NO_AVAIL: { key: 'NO_AVAIL', label: '无效' },
}
/** 检查类型 **/
export const PHOTOEXAMINE_TYPE = {
  M_3: { key: '3', label: '农户自查' },
  M_7: { key: '7', label: '商户自查' },
  M_5: { key: '5', label: '收集员检查' },
}
/** 预约状态 **/
export const APPOINTMENT_STATUS = {
  appoint: { key: '1', label: '预约', color: '#ed4014' },
  handle: { key: '2', label: '处理', color: '#2d8cf0' },
  finish: { key: '3', label: '完成', color: '#5dc8b2' },
}

export const TYPE_LIST = {
  day: { key: 'day', label: '按日统计', color: '#ed4014' },
  month: { key: 'month', label: '按月统计', color: '#2d8cf0' },
}

export const YEAR_LIST = {
  year_2017: { key: 2017, label: "2017年" },
  year_2018: { key: 2018, label: "2018年" },
  year_2019: { key: 2019, label: "2019年" },
  year_2020: { key: 2020, label: "2020年" },
  year_2021: { key: 2021, label: "2021年" },
  year_2022: { key: 2022, label: "2022年" },
  year_2023: { key: 2023, label: "2023年" },
  year_2024: { key: 2024, label: "2024年" },
  year_2025: { key: 2025, label: "2025年" },
  year_2026: { key: 2026, label: "2026年" },
  year_2027: { key: 2027, label: "2027年" },
  year_2028: { key: 2028, label: "2028年" },
  year_2029: { key: 2029, label: "2029年" },
  year_2030: { key: 2030, label: "2030年" },
}

export const MONTH_LIST = {
  month_1: { key: '01', label: "一月" },
  month_2: { key: '02', label: "二月" },
  month_3: { key: '03', label: "三月" },
  month_4: { key: '04', label: "四月" },
  month_5: { key: '05', label: "五月" },
  month_6: { key: '06', label: "六月" },
  month_7: { key: '07', label: "七月" },
  month_8: { key: '08', label: "八月" },
  month_9: { key: '09', label: "九月" },
  month_10: { key: '10', label: "十月" },
  month_11: { key: '11', label: "十一月" },
  month_12: { key: '12', label: "十二月" },
}

export const DAYS_LIST = {
  days_1: { key: '01', label: "1日" },
  days_2: { key: '02', label: "2日" },
  days_3: { key: '03', label: "3日" },
  days_4: { key: '04', label: "4日" },
  days_5: { key: '05', label: "5日" },
  days_6: { key: '06', label: "6日" },
  days_7: { key: '07', label: "7日" },
  days_8: { key: '08', label: "8日" },
  days_9: { key: '09', label: "9日" },
  days_10: { key: '10', label: "10日" },
  days_11: { key: '11', label: "11日" },
  days_12: { key: '12', label: "12日" },
  days_13: { key: '13', label: "13日" },
  days_14: { key: '14', label: "14日" },
  days_15: { key: '15', label: "15日" },
  days_16: { key: '16', label: "16日" },
  days_17: { key: '17', label: "17日" },
  days_18: { key: '18', label: "18日" },
  days_19: { key: '19', label: "19日" },
  days_20: { key: '20', label: "20日" },
  days_21: { key: '21', label: "21日" },
  days_22: { key: '22', label: "22日" },
  days_23: { key: '23', label: "23日" },
  days_24: { key: '24', label: "24日" },
  days_25: { key: '25', label: "25日" },
  days_26: { key: '26', label: "26日" },
  days_27: { key: '27', label: "27日" },
  days_28: { key: '28', label: "28日" },
  days_29: { key: '29', label: "29日" },
  days_30: { key: '30', label: "30日" },
  days_31: { key: '31', label: "31日" },
};
/** 积分类型 **/
export const TRADEFLOW_SUBACCOUNT = {
  Integral_1: { key: '10000', label: "第三方奖励积分" },
  Integral_2: { key: '10001', label: "政府奖励积分" },
  Integral_3: { key: '10002', label: "第三方现金积分" },
  Integral_4: { key: '10004', label: "红包奖励积分" },

}
/** 积分兑换订单状态 integralExchange **/
export const INTEGRAL_EXCHANGE = {
  order_1: { key: '1', label: "兑换中" },
  order_2: { key: '2', label: "已兑换" },
  order_3: { key: '3', label: "已取消" },
}


/** 活动场景 **/
export const REDBAGCASECONFIG_CASESCENE = {
  RED_BAG_AD_APPOINT: { key: 'RED_BAG_AD_APPOINT', label: '预约广告' },
  RED_BAG_AD_CHECKSELF: { key: 'RED_BAG_AD_CHECKSELF', label: '自查广告' },
  RED_BAG_AD_SIGN: { key: 'RED_BAG_AD_SIGN', label: '签到广告' },
}


/** 奖励积分状态 **/
export const BOUNSPOINT_STATUS = {
  YES: { key: 'YES', label: '已到账' },
  NO: { key: 'NO', label: '未到账' },
}


/** 宣传图状态 **/
export const PROGAGATEIMG_STATUS = {
  valid: { key: 'valid', label: '启用' },
  invalid: { key: 'invalid', label: '禁用' },
}
/** s商品状态 **/
export const GOODS_STATUS = {
  on: { key: 'on', label: '启用' },
  off: { key: 'off', label: '下架' },
}

export const RANK_PARENT_TYPE = {
  //第一行
  ORGEN_SORT_BONUS_YEAR_GOOD_RANK: 'ORGEN_SORT_BONUS_YEAR_GOOD_RANK',//单位综合排名
  ORGEN_SELF_CHECK_YEAR_GOOD_RANK: 'ORGEN_SELF_CHECK_YEAR_GOOD_RANK',//单位自查率排名
  ORGEN_CHECK_YEAR_GOOD_RANK: 'ORGEN_CHECK_YEAR_GOOD_RANK',//单位被督查次数排名
  ORGEN_SELF_COLLECT_YEAR_GOOD_RANK: 'ORGEN_SELF_COLLECT_YEAR_GOOD_RANK',//单位投放率排名
  ORGEN_SELF_COLLECT_GOOD_YEAR_GOOD_RANK: 'ORGEN_SELF_COLLECT_GOOD_YEAR_GOOD_RANK',//单位投放准确率排名
  ORGAN_TOTAL_BONUS_RANK: 'ORGAN_TOTAL_BONUS_RANK',//单位积分汇总
  ORGAN_GRADE_PLAN_MERCHANT_RANK: 'ORGAN_GRADE_PLAN_MERCHANT_RANK',//商户评星情况汇总
  ORGAN_GRADE_PLAN_MERCHANT_MONTH_RANK: 'ORGAN_GRADE_PLAN_MERCHANT_MONTH_RANK',//商户评星月度
  //第二行
  PERSON_SORT_BONUS_YEAR_RANK: 'PERSON_SORT_BONUS_YEAR_RANK',//个人综合排名
  PERSON_SELF_CHECK_CURR_YEAR_RANK: 'PERSON_SELF_CHECK_CURR_YEAR_RANK',//个人自查率排名
  PERSON_CHECK_CURR_YEAR_RANK: 'PERSON_CHECK_CURR_YEAR_RANK',//个人被督查次数排名
  PERSON_SELF_COLLECT_YEAR_RANK: 'PERSON_SELF_COLLECT_YEAR_RANK',//个人投放率排名
  PERSON_SELF_COLLECT_GOOD_YEAR_RANK: 'PERSON_SELF_COLLECT_GOOD_YEAR_RANK',//个人投放准确率排名
  PERSON_TOTAL_BONUS_RANK: 'PERSON_TOTAL_BONUS_RANK',//个人积分汇总
  PERSON_AWARD_BONUS_RANK: 'PERSON_AWARD_BONUS_RANK',//个人奖励排名
  //第三行
  PARTY_SORT_BONUS_YEAR_RANK: 'PARTY_SORT_BONUS_YEAR_RANK',//党员综合排名
  PARTY_SELF_CHECK_CURR_YEAR_RANK: 'PARTY_SELF_CHECK_CURR_YEAR_RANK',//党员自查率排名
  PARTY_CHECK_CURR_YEAR_RANK: 'PARTY_CHECK_CURR_YEAR_RANK',//党员被督查次数排名
  PARTY_SELF_COLLECT_YEAR_RANK: 'PARTY_SELF_COLLECT_YEAR_RANK',//党员投放率排名
  PARTY_SELF_COLLECT_GOOD_YEAR_RANK: 'PARTY_SELF_COLLECT_GOOD_YEAR_RANK',//党员投放准确率排名
  PARTY_TOTAL_BONUS_RANK: 'PARTY_TOTAL_BONUS_RANK',//党员积分汇总
  //第四行
  SITE_SORT_BONUS_YEAR_RANK: 'SITE_SORT_BONUS_YEAR_RANK',//亭内综合排名
  SITE_SELF_CHECK_CURR_YEAR_RANK: 'SITE_SELF_CHECK_CURR_YEAR_RANK',//亭内自查率排名
  SITE_CHECK_CURR_YEAR_RANK: 'SITE_CHECK_CURR_YEAR_RANK',//亭内被督查次数排名
  SITE_SELF_COLLECT_YEAR_RANK: 'SITE_SELF_COLLECT_YEAR_RANK',//亭内投放率排名
  SITE_SELF_COLLECT_GOOD_YEAR_RANK: 'SITE_SELF_COLLECT_GOOD_YEAR_RANK',//亭内投放准确率排名
  SITE_TOTAL_BONUS_RANK: 'SITE_TOTAL_BONUS_RANK',//亭内积分汇总
}

/** 排名类型 **/
export const RANK_AREA_TYPE = {
  CITYRANK: { key: 'CITYRANK', label: '区排名' },
  TOWNRANK: { key: 'TOWNRANK', label: '镇排名' },
  VILLAGERANK: { key: 'VILLAGERANK', label: '村排名' },
}
/** 统计维度 **/
export const STATISTICAL_DIMENSION = {
  year: { key: 'year', label: '年度' },
  halfYear: { key: 'halfYear', label: '半年度' },
  season: { key: 'season', label: '季度' },
  month: { key: 'month', label: '月度' },
}
/** 目标类型 **/
export const TARGET_TYPE = {
  ORGAN_TOWN: { key: 'ORGAN_TOWN', label: '--镇排名--' },
  ORGAN_VILLAGE: { key: 'ORGAN_VILLAGE', label: '--村排名--' },
  ORGAN_COMMUNITY: { key: 'ORGAN_COMMUNITY', label: '--社区排名--' },
}
export const TARGET_TYPE2 = {
  ORGAN_VILLAGE: { key: 'ORGAN_VILLAGE', label: '--村积分--' },
  ORGAN_PART: { key: 'ORGAN_PART', label: '--片区积分--' },
}
/** 半年度 **/
export const RANK_HALF_YEAR = {
  uphalfYear: { key: 'uphalfYear', label: '上半年' },
  downhalfYear: { key: 'downhalfYear', label: '下半年' },
}
/** 季度 */
export const RANK_SEASON = {
  s1: { key: 's1', label: '一季度' },
  s2: { key: 's2', label: '二季度' },
  s3: { key: 's3', label: '三季度' },
  s4: { key: 's4', label: '四季度' },
}
/** 家庭类型 */
export const USER_LABEL = {
  cadre_family: { key: 'cadre_family', label: '干部户' },
}

/** 授权码状态 **/
export const WARRANT_TYPE = {
  valid: { key: 'valid', label: '有效的' },
  invalid: { key: 'invalid', label: '无效的' },
}

/** 授权码渠道状态 **/
export const CHANNEL_TYPE = {
  xiaosheng: { key: 'xiaosheng', label: '小圣' },
  jiaao: { key: 'jiaao', label: '加奥' },
  zhipeng: { key: 'zhipeng', label: '智鹏' },
  lafei: { key: 'invalid', label: '垃非' },
}


/** 回收站点类型 **/
export const RECTCLESITE_TYPE = {
  RECTCLESITE1: { key: '1', label: '清运点' },
  RECTCLESITE2: { key: '2', label: '回收站  ' },
  RECTCLESITE3: { key: '3', label: '垃圾亭' },
}

export const RECYCLINGSCENE_TYPE = {
  RECYCLINGSCENE9: { key: '9000', label: '回收员向农户回收' },
}


export const PROPAGATEIMG_TYPE = {
  industry: { key: 'industry', label: '行业动态宣传图' },
  banner: { key: 'banner', label: '首页宣传图' },
  appLoading: { key: 'appLoading', label: 'APPLoading页' },
  notice: { key: 'notice', label: '通知公告宣传图' },
  policy: { key: 'policy', label: '政策文件宣传图' },
  business: { key: 'business', label: '企业新闻宣传图' },
  enterpriseCredit: { key: 'enterpriseCredit', label: '企业信用宣传图' },
  researchersCredit: { key: 'researchersCredit', label: '人员信用宣传图' },
}
export const STARCROWD_TYPE = {
  merchant: { key: 'merchant', label: '商户' },
  generatUser: { key: 'generatUser', label: '用户' },
}


export const PORT_TYPE = {
  app: { key: 'app', label: '移动端' },
  web: { key: 'web', label: '后台端' },
}

export const BUILTIN_TYPE = {
  no: { key: 'no', label: '否' },
  yes: { key: 'yes', label: '是' },
}

//绑定状态
export const BINGIING_STATUS = {
  Binging1: { key: 1, label: '已绑定' },
  Binging2: { key: 0, label: '已解绑 ' },
}

//供应商 
export const SUPPLIER = {
  SUPPLIER1: { key: 1, label: '浦江鑫旺' },
  SUPPLIER2: { key: 2, label: '浦江鑫旺3 ' },
  SUPPLIER3: { key: 3, label: '德清大成 ' },
  SUPPLIER4: { key: 4, label: '杭州越洋 ' },
}
// 签到合格
export const SIGNSCORE_STATUS = {
  signScore50: { key: 50, label: '不合格' },
  signScore100: { key: 100, label: '合格 ' },
}

// 自查设备通道
export const EQPCHANNEL_TYPE = {
  xiaosheng: { key: 'xiaosheng', label: '绿景华庭收集机' },
  zhipeng: { key: 'zhipeng', label: '美迪家园易腐垃圾收集机 ' },
  jiaao: { key: 'jiaao', label: '新丰镇东方润园 ' },
}

export const SCORE_TYPE = {
  CHECK_SUBMIT: { key: 'CHECK_SUBMIT', label: '未评' },
  APPROVE_TOTAL_YES: { key: 'APPROVE_TOTAL_YES', label: '好 ' },
  APPROVE_NO: { key: 'APPROVE_NO', label: '差 ' },
  NO_AVAIL: { key: 'NO_AVAIL', label: '无效  ' },
}
// 交易状态
export const TRADE_STATUS = {
  SUCCESS: { key: 'SUCCESS', label: '交易成功' },
  STEPBACK: { key: 'STEPBACK', label: '已退回 ' },
}

// 商户提现状态
export const WITHDRAWAL_STATUS = {
  APPLY: { key: 'APPLY', label: '申请' },
  REFUSE: { key: 'REFUSE', label: '拒绝 ' },
  DEALING: { key: 'DEALING', label: ' 处理中 ' },
  SUCCESS: { key: 'SUCCESS', label: '成功 ' },
  FAIL: { key: 'FAIL', label: '失败 ' },
}

// 机构类型
export const ORGAN_TYPE = {
  site : { key: 'site ', label: '亭' },
  organ: { key: 'organ', label: '单位 ' },
  community: { key: 'community', label: ' 社区 ' },
}
// 机构类型
export const RECOVERYCHECK = {
  true : { key: '1 ', label: '是' },
  false: { key: '0', label: '否 ' },
}
         
  // 检查类型
export const CHECKTYPE = {
  SELFCHECK : { key: 'SELFCHECK', label: '自查' },
  INSPECTCHECK : { key: 'INSPECTCHECK', label: '督查' },
}

/** 回收站点管理类型 **/
export const RECTCLESITES_TYPE = {
  RECTCLESITE1: { key: '1', label: '中转站' },
  RECTCLESITE2: { key: '3', label: '垃圾亭' },
  RECTCLESITE3: { key: '4', label: '定时定点投放屋' },
  RECTCLESITE4: { key: '5', label: '易腐垃圾处理站' }
}

/** 自助回收审核状态 **/
export const SELFHELPRECOVERY_STATUS = {
  SUCC: { key: 'SUCC', label: '通过' },
  FAIL: { key: 'FAIL', label: '拒绝' },
}

/** 清运类型 **/
export const CLEAR_TYPE_LIST = {
  rot: { key: '4', label: '易腐垃圾清运', color: '#2d8cf0' },
  other: { key: '14', label: '其他垃圾清运', color: '#2d8cf0' },
  recover: { key: '28', label: '回收垃圾清运', color: '#2d8cf0' },
  harm: { key: '29', label: '有害垃圾清运', color: '#2d8cf0' },
}
            
/** 督查结果 **/
export const INSPECT_RESULT = {
  COMPLETE_SORT: { key: 'COMPLETE_SORT', label: '好' },
  BASIC_SORT: { key: 'BASIC_SORT', label: '中' },
  BASIC_NOT_SORT: { key: 'BASIC_NOT_SORT', label: '差' },
}   


// WEBPACK FOOTER //
// ./src/constant/Enums.js